// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__+3Hk2","item":"pagination_item__8nS+s","disabled":"pagination_disabled__amcA0"};